import * as React from 'react';
import { Select } from '@blueprintjs/select'
import { Role, Roles } from '../models/role.model';
import { FormGroup, Button, MenuItem } from '@blueprintjs/core';

const BlueprintSelect = Select.ofType<Role>();

export interface Props {
  inline?: boolean
  label?: string
  role: string
  onChange: (role: Role) => void
}

export function RoleSelect({ onChange, role, label, inline = false }: Props) {
  const [ currentRole, setCurrentRole ] = React.useState({} as Role);

  React.useEffect(() => {
    const _role = Roles.find(r => r.code === role)
    if (_role) {
      setCurrentRole(_role)
    }
  }, [role]);

  if (!currentRole) {
    return null
  }

  return (
    <FormGroup inline={inline} label={label}>
      <BlueprintSelect
        filterable={false}
        items={Roles}
        activeItem={currentRole}
        itemRenderer={(item, options) => <MenuItem 
          key={item.code}
          text={item.name}
          onClick={options.handleClick}
        />}
        onItemSelect={role => {
          onChange(role)}
        }
      >
        <Button text={currentRole.name} rightIcon="chevron-down" minimal/>
      </BlueprintSelect>
    </FormGroup>
  );
}
